<template>

	<div class="main_footer_phone">
		<div class="email_icon"></div>
		<div class="main_footer_content_2" style="color: #000000;">
			sales@aidoeasy.com
		</div>

		<div class="main_footer_content_position_phone" style="margin-bottom: 10px;">
			武汉市洪山区关东科技工业园
		</div>
		<div class="position_icon"></div>

		<div class="main_footer_content_4" style="color: #000000;">
			版权所有 Copyright © 2024 武汉为之易科技有限公司
			<br />
			All Rights Reserved.<a style="color: #000000;" class="main_footer_content_4" target="_blank"
				href="https://beian.miit.gov.cn">鄂ICP备2024087820号-1</a>
		</div>

	</div>
	<div class="main_footer">
		<div class="main_footer_content_1">
			<div class="footer_menu">
				<div class="footer_menu_item" @click="show_one_product('page1')">
					首页
				</div>
				<div class="footer_menu_item" @click="show_one_product('page2')">
					产品中心
				</div>
				<div class="footer_menu_item" @click="show_one_product('page3')">
					项目案例
				</div>
				<div class="footer_menu_item" @click="show_one_product('page7')">
					行业应用
				</div>
				<div class="footer_menu_item" @click="show_one_product('page5')">
					关于我们
				</div>
				<div class="footer_menu_item" @click="show_one_product('page6')">
					联系方式
				</div>
			</div>
		</div>

		<div class="main_footer_content_2" style="color: #000000;">
			sales@aidoeasy.com
		</div>
		<div class="email_icon"></div>
		<div class="main_footer_content_2" style="margin-bottom: 10px;color: #000000;width: 240px;">
			武汉市洪山区关东科技工业园
		</div>
		<div class="position_icon"></div>
		<!-- 		<div class="main_footer_content_2">
			服务热线：
		</div> -->
		<!-- 		<div class="main_footer_content_3">
			15927666885
		</div> -->
		<div class="main_footer_content_4" style="color: #000000;">
			版权所有 Copyright © 2024 武汉为之易科技有限公司 All Rights Reserved.<a style="color: #000000;"
				class="main_footer_content_4" target="_blank" href="https://beian.miit.gov.cn">鄂ICP备2024087820号-1</a>
		</div>
		<!-- 		<div style="width: 100%;height: 100%;position: absolute;">
			
			
		</div> -->

	</div>
</template>

<script>
export default {
	name: "Aside",
	methods: {
		show_one_product(id) {
			let new_route = ""
			if (id == "page1") {
				new_route = "index"
			} else if (id == "page2") {
				new_route = "product_center"
			} else if (id == "page3") {
				new_route = "project_case"
			} else if (id == "page5") {
				new_route = "about_us"
			} else if (id == "page6") {
				new_route = "contact_information"
			} else if (id == "page7") {
				new_route = "industry_applications"
			}
			document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0
			this.$GLOBAL.methods.init_header_menu(id)
			window.localStorage.setItem("main_path", id);
			this.$router.push("/main/" + new_route)
		},
	}
}
</script>

<style></style>